export const SOURCE_ID = 'fema-flood-hazard';
export const SOURCE_LAYER = 'flood_zones';
export const FEMA_FLOOD_HAZARD_FILL_LAYER_ID = 'fema-flood-hazard-fill';
export const FEMA_FLOOD_HAZARD_STROKE_LAYER_ID = 'fema-flood-hazard-stroke';
export const FEMA_FLOOD_HAZARD_PATTERN_LAYER_ID = 'fema-flood-hazard-pattern';
export const FEMA_FLOOD_HAZARD_SELECTED_FILL_LAYER_ID =
  'fema-flood-hazard-selected-fill';
export const FEMA_FLOOD_HAZARD_SELECTED_STROKE_LAYER_ID =
  'fema-flood-hazard-selected-stroke';

export const MIN_ZOOM_LEVEL = 5;

export const FLOOD_HAZARD_COLOR = '#865c98';

export const FLOOD_UNDETERMINED_COLOR = '#000000';
